import { SursaSnapshotPanel } from "../components/SursaSnapshotPanel";

export default function BilanturiMf() {
  return (
    <SursaSnapshotPanel
      sursa="mf_bilant"
      descriere={
        <>
          Situațiile financiare anuale (MF): salariați, cifră de afaceri,
          active, pe (CUI, an). Rectificările se aplică prin upsert doar unde
          hash-ul indicatorilor s-a schimbat. Verificarea de siguranță compară
          200 de CUI-uri martor cu anul precedent (fiecare indicator între 0,2×
          și 5×); sub 90 % din martori în interval, aplicarea se oprește fără
          „forțează”.
        </>
      }
      comandaScript={
        'python -m scripts.actualizare.actualizare bilant --proiect dev --sursa "../Bilanturi FIRME 2025" --an 2025'
      }
    />
  );
}
